// source: witbooking/backoffice/insurance/v1/insurance_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.BookableRefInventory', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.Insurance', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.InsuranceCalculationBase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.InsuranceTaxation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.Rate', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.Rate.RateTypeCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.RateConstant', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.RatePercentage', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.RestrictionMinStay', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.Restrictions', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.Translation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.Typology', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.Typology.TypologyDetailCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.TypologyAmount', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.TypologyPercentage', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.TypologySection', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.displayName = 'proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.displayName = 'proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.displayName = 'proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.displayName = 'proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.displayName = 'proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.displayName = 'proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.displayName = 'proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.displayName = 'proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.displayName = 'proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.displayName = 'proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.displayName = 'proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.displayName = 'proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.Insurance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.insurance.v1.Insurance.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.Insurance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.Insurance.displayName = 'proto.witbooking.backoffice.insurance.v1.Insurance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.insurance.v1.BookableRefInventory.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.BookableRefInventory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.BookableRefInventory.displayName = 'proto.witbooking.backoffice.insurance.v1.BookableRefInventory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.Translation.displayName = 'proto.witbooking.backoffice.insurance.v1.Translation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.Typology = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.insurance.v1.Typology.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.Typology, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.Typology.displayName = 'proto.witbooking.backoffice.insurance.v1.Typology';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.insurance.v1.TypologyPercentage.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.TypologyPercentage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.TypologyPercentage.displayName = 'proto.witbooking.backoffice.insurance.v1.TypologyPercentage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.insurance.v1.TypologyAmount.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.TypologyAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.TypologyAmount.displayName = 'proto.witbooking.backoffice.insurance.v1.TypologyAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.TypologySection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.TypologySection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.TypologySection.displayName = 'proto.witbooking.backoffice.insurance.v1.TypologySection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.Restrictions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.Restrictions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.Restrictions.displayName = 'proto.witbooking.backoffice.insurance.v1.Restrictions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinStay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.RestrictionMinStay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.displayName = 'proto.witbooking.backoffice.insurance.v1.RestrictionMinStay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.displayName = 'proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.displayName = 'proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.displayName = 'proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.Rate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.insurance.v1.Rate.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.Rate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.Rate.displayName = 'proto.witbooking.backoffice.insurance.v1.Rate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.RatePercentage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.RatePercentage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.RatePercentage.displayName = 'proto.witbooking.backoffice.insurance.v1.RatePercentage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.RateConstant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.RateConstant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.RateConstant.displayName = 'proto.witbooking.backoffice.insurance.v1.RateConstant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.insurance.v1.InsuranceTaxation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.displayName = 'proto.witbooking.backoffice.insurance.v1.InsuranceTaxation';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest;
  return proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest} returns this
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    insurance: (f = msg.getInsurance()) && proto.witbooking.backoffice.insurance.v1.Insurance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse;
  return proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.Insurance;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Insurance.deserializeBinaryFromReader);
      msg.setInsurance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInsurance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.Insurance.serializeBinaryToWriter
    );
  }
};


/**
 * optional Insurance insurance = 1;
 * @return {?proto.witbooking.backoffice.insurance.v1.Insurance}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.prototype.getInsurance = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Insurance} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Insurance, 1));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Insurance|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse} returns this
*/
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.prototype.setInsurance = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse} returns this
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.prototype.clearInsurance = function() {
  return this.setInsurance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.GetInsuranceResponse.prototype.hasInsurance = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    insurance: (f = msg.getInsurance()) && proto.witbooking.backoffice.insurance.v1.Insurance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest;
  return proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.Insurance;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Insurance.deserializeBinaryFromReader);
      msg.setInsurance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInsurance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.Insurance.serializeBinaryToWriter
    );
  }
};


/**
 * optional Insurance insurance = 1;
 * @return {?proto.witbooking.backoffice.insurance.v1.Insurance}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.prototype.getInsurance = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Insurance} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Insurance, 1));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Insurance|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest} returns this
*/
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.prototype.setInsurance = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest} returns this
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.prototype.clearInsurance = function() {
  return this.setInsurance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceRequest.prototype.hasInsurance = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    insurance: (f = msg.getInsurance()) && proto.witbooking.backoffice.insurance.v1.Insurance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse;
  return proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.Insurance;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Insurance.deserializeBinaryFromReader);
      msg.setInsurance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInsurance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.Insurance.serializeBinaryToWriter
    );
  }
};


/**
 * optional Insurance insurance = 1;
 * @return {?proto.witbooking.backoffice.insurance.v1.Insurance}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.prototype.getInsurance = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Insurance} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Insurance, 1));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Insurance|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse} returns this
*/
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.prototype.setInsurance = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse} returns this
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.prototype.clearInsurance = function() {
  return this.setInsurance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.CreateInsuranceResponse.prototype.hasInsurance = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    insurance: (f = msg.getInsurance()) && proto.witbooking.backoffice.insurance.v1.Insurance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest;
  return proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.insurance.v1.Insurance;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Insurance.deserializeBinaryFromReader);
      msg.setInsurance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInsurance();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.insurance.v1.Insurance.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} returns this
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Insurance insurance = 2;
 * @return {?proto.witbooking.backoffice.insurance.v1.Insurance}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.prototype.getInsurance = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Insurance} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Insurance, 2));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Insurance|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} returns this
*/
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.prototype.setInsurance = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest} returns this
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.prototype.clearInsurance = function() {
  return this.setInsurance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceRequest.prototype.hasInsurance = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    insurance: (f = msg.getInsurance()) && proto.witbooking.backoffice.insurance.v1.Insurance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse;
  return proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.Insurance;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Insurance.deserializeBinaryFromReader);
      msg.setInsurance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInsurance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.Insurance.serializeBinaryToWriter
    );
  }
};


/**
 * optional Insurance insurance = 1;
 * @return {?proto.witbooking.backoffice.insurance.v1.Insurance}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.prototype.getInsurance = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Insurance} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Insurance, 1));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Insurance|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse} returns this
*/
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.prototype.setInsurance = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse} returns this
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.prototype.clearInsurance = function() {
  return this.setInsurance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.UpdateInsuranceResponse.prototype.hasInsurance = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest;
  return proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    insurancesList: jspb.Message.toObjectList(msg.getInsurancesList(),
    proto.witbooking.backoffice.insurance.v1.Insurance.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse;
  return proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.Insurance;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Insurance.deserializeBinaryFromReader);
      msg.addInsurances(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInsurancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.Insurance.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Insurance insurances = 1;
 * @return {!Array<!proto.witbooking.backoffice.insurance.v1.Insurance>}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.prototype.getInsurancesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.insurance.v1.Insurance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.insurance.v1.Insurance, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.insurance.v1.Insurance>} value
 * @return {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse} returns this
*/
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.prototype.setInsurancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.Insurance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance}
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.prototype.addInsurances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.insurance.v1.Insurance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse} returns this
 */
proto.witbooking.backoffice.insurance.v1.GetAllInsurancesResponse.prototype.clearInsurancesList = function() {
  return this.setInsurancesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest;
  return proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest} returns this
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse;
  return proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.DeleteInsuranceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    beforeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    afterId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest;
  return proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBeforeId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfterId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeforeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAfterId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string before_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.prototype.getBeforeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest} returns this
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.prototype.setBeforeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string after_id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.prototype.getAfterId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest} returns this
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceRequest.prototype.setAfterId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse;
  return proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.ReorderInsuranceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.insurance.v1.Insurance.repeatedFields_ = [4,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.Insurance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.Insurance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Insurance.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.insurance.v1.Translation.toObject, includeInstance),
    appliesToInventories: (f = msg.getAppliesToInventories()) && proto.witbooking.backoffice.insurance.v1.BookableRefInventory.toObject(includeInstance, f),
    taxesList: jspb.Message.toObjectList(msg.getTaxesList(),
    proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.toObject, includeInstance),
    feesList: jspb.Message.toObjectList(msg.getFeesList(),
    proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.toObject, includeInstance),
    typology: (f = msg.getTypology()) && proto.witbooking.backoffice.insurance.v1.Typology.toObject(includeInstance, f),
    validFrom: (f = msg.getValidFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    validTo: (f = msg.getValidTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    restrictions: (f = msg.getRestrictions()) && proto.witbooking.backoffice.insurance.v1.Restrictions.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    calculationBase: jspb.Message.getFieldWithDefault(msg, 14, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.Insurance;
  return proto.witbooking.backoffice.insurance.v1.Insurance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.Insurance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.insurance.v1.Translation;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.insurance.v1.BookableRefInventory;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.BookableRefInventory.deserializeBinaryFromReader);
      msg.setAppliesToInventories(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.insurance.v1.InsuranceTaxation;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.deserializeBinaryFromReader);
      msg.addTaxes(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.insurance.v1.InsuranceTaxation;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.deserializeBinaryFromReader);
      msg.addFees(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.insurance.v1.Typology;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Typology.deserializeBinaryFromReader);
      msg.setTypology(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValidFrom(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValidTo(value);
      break;
    case 11:
      var value = new proto.witbooking.backoffice.insurance.v1.Restrictions;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Restrictions.deserializeBinaryFromReader);
      msg.setRestrictions(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 14:
      var value = /** @type {!proto.witbooking.backoffice.insurance.v1.InsuranceCalculationBase} */ (reader.readEnum());
      msg.setCalculationBase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.Insurance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.Insurance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Insurance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.witbooking.backoffice.insurance.v1.Translation.serializeBinaryToWriter
    );
  }
  f = message.getAppliesToInventories();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.insurance.v1.BookableRefInventory.serializeBinaryToWriter
    );
  }
  f = message.getTaxesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.serializeBinaryToWriter
    );
  }
  f = message.getFeesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.serializeBinaryToWriter
    );
  }
  f = message.getTypology();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.insurance.v1.Typology.serializeBinaryToWriter
    );
  }
  f = message.getValidFrom();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getValidTo();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRestrictions();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.witbooking.backoffice.insurance.v1.Restrictions.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCalculationBase();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool active = 3;
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated Translation translations = 4;
 * @return {!Array<!proto.witbooking.backoffice.insurance.v1.Translation>}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.insurance.v1.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.insurance.v1.Translation, 4));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.insurance.v1.Translation>} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.insurance.v1.Translation}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.backoffice.insurance.v1.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional BookableRefInventory applies_to_inventories = 5;
 * @return {?proto.witbooking.backoffice.insurance.v1.BookableRefInventory}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getAppliesToInventories = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.BookableRefInventory} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.BookableRefInventory, 5));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.BookableRefInventory|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setAppliesToInventories = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearAppliesToInventories = function() {
  return this.setAppliesToInventories(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.hasAppliesToInventories = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated InsuranceTaxation taxes = 6;
 * @return {!Array<!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation>}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getTaxesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.insurance.v1.InsuranceTaxation, 6));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation>} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setTaxesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.addTaxes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.witbooking.backoffice.insurance.v1.InsuranceTaxation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearTaxesList = function() {
  return this.setTaxesList([]);
};


/**
 * repeated InsuranceTaxation fees = 7;
 * @return {!Array<!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation>}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getFeesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.insurance.v1.InsuranceTaxation, 7));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation>} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setFeesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.addFees = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.witbooking.backoffice.insurance.v1.InsuranceTaxation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearFeesList = function() {
  return this.setFeesList([]);
};


/**
 * optional Typology typology = 8;
 * @return {?proto.witbooking.backoffice.insurance.v1.Typology}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getTypology = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Typology} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Typology, 8));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Typology|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setTypology = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearTypology = function() {
  return this.setTypology(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.hasTypology = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp valid_from = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getValidFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setValidFrom = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearValidFrom = function() {
  return this.setValidFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.hasValidFrom = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp valid_to = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getValidTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setValidTo = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearValidTo = function() {
  return this.setValidTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.hasValidTo = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Restrictions restrictions = 11;
 * @return {?proto.witbooking.backoffice.insurance.v1.Restrictions}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getRestrictions = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Restrictions} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Restrictions, 11));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Restrictions|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setRestrictions = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearRestrictions = function() {
  return this.setRestrictions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.hasRestrictions = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
*/
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional InsuranceCalculationBase calculation_base = 14;
 * @return {!proto.witbooking.backoffice.insurance.v1.InsuranceCalculationBase}
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.getCalculationBase = function() {
  return /** @type {!proto.witbooking.backoffice.insurance.v1.InsuranceCalculationBase} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.InsuranceCalculationBase} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Insurance} returns this
 */
proto.witbooking.backoffice.insurance.v1.Insurance.prototype.setCalculationBase = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.BookableRefInventory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.BookableRefInventory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.toObject = function(includeInstance, msg) {
  var f, obj = {
    tickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.BookableRefInventory}
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.BookableRefInventory;
  return proto.witbooking.backoffice.insurance.v1.BookableRefInventory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.BookableRefInventory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.BookableRefInventory}
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.BookableRefInventory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.BookableRefInventory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.prototype.getTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.insurance.v1.BookableRefInventory} returns this
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.prototype.setTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.insurance.v1.BookableRefInventory} returns this
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.prototype.addTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.insurance.v1.BookableRefInventory} returns this
 */
proto.witbooking.backoffice.insurance.v1.BookableRefInventory.prototype.clearTickersList = function() {
  return this.setTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.Translation}
 */
proto.witbooking.backoffice.insurance.v1.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.Translation;
  return proto.witbooking.backoffice.insurance.v1.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.Translation}
 */
proto.witbooking.backoffice.insurance.v1.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.Translation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Translation} returns this
 */
proto.witbooking.backoffice.insurance.v1.Translation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.Translation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Translation} returns this
 */
proto.witbooking.backoffice.insurance.v1.Translation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.Translation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Translation} returns this
 */
proto.witbooking.backoffice.insurance.v1.Translation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.insurance.v1.Typology.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.insurance.v1.Typology.TypologyDetailCase = {
  TYPOLOGY_DETAIL_NOT_SET: 0,
  PERCENTAGE: 1,
  AMOUNT: 2
};

/**
 * @return {proto.witbooking.backoffice.insurance.v1.Typology.TypologyDetailCase}
 */
proto.witbooking.backoffice.insurance.v1.Typology.prototype.getTypologyDetailCase = function() {
  return /** @type {proto.witbooking.backoffice.insurance.v1.Typology.TypologyDetailCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.insurance.v1.Typology.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.Typology.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.Typology.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.Typology} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Typology.toObject = function(includeInstance, msg) {
  var f, obj = {
    percentage: (f = msg.getPercentage()) && proto.witbooking.backoffice.insurance.v1.TypologyPercentage.toObject(includeInstance, f),
    amount: (f = msg.getAmount()) && proto.witbooking.backoffice.insurance.v1.TypologyAmount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.Typology}
 */
proto.witbooking.backoffice.insurance.v1.Typology.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.Typology;
  return proto.witbooking.backoffice.insurance.v1.Typology.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.Typology} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.Typology}
 */
proto.witbooking.backoffice.insurance.v1.Typology.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.TypologyPercentage;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.TypologyPercentage.deserializeBinaryFromReader);
      msg.setPercentage(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.insurance.v1.TypologyAmount;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.TypologyAmount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.Typology.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.Typology.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.Typology} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Typology.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPercentage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.TypologyPercentage.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.insurance.v1.TypologyAmount.serializeBinaryToWriter
    );
  }
};


/**
 * optional TypologyPercentage percentage = 1;
 * @return {?proto.witbooking.backoffice.insurance.v1.TypologyPercentage}
 */
proto.witbooking.backoffice.insurance.v1.Typology.prototype.getPercentage = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.TypologyPercentage} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.TypologyPercentage, 1));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.TypologyPercentage|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Typology} returns this
*/
proto.witbooking.backoffice.insurance.v1.Typology.prototype.setPercentage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.insurance.v1.Typology.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Typology} returns this
 */
proto.witbooking.backoffice.insurance.v1.Typology.prototype.clearPercentage = function() {
  return this.setPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Typology.prototype.hasPercentage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TypologyAmount amount = 2;
 * @return {?proto.witbooking.backoffice.insurance.v1.TypologyAmount}
 */
proto.witbooking.backoffice.insurance.v1.Typology.prototype.getAmount = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.TypologyAmount} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.TypologyAmount, 2));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.TypologyAmount|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Typology} returns this
*/
proto.witbooking.backoffice.insurance.v1.Typology.prototype.setAmount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.insurance.v1.Typology.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Typology} returns this
 */
proto.witbooking.backoffice.insurance.v1.Typology.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Typology.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.TypologyPercentage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologyPercentage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.toObject = function(includeInstance, msg) {
  var f, obj = {
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.witbooking.backoffice.insurance.v1.TypologySection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologyPercentage}
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.TypologyPercentage;
  return proto.witbooking.backoffice.insurance.v1.TypologyPercentage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologyPercentage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologyPercentage}
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.TypologySection;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.TypologySection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.TypologyPercentage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologyPercentage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.TypologySection.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TypologySection sections = 1;
 * @return {!Array<!proto.witbooking.backoffice.insurance.v1.TypologySection>}
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.insurance.v1.TypologySection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.insurance.v1.TypologySection, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.insurance.v1.TypologySection>} value
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologyPercentage} returns this
*/
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologySection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection}
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.insurance.v1.TypologySection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologyPercentage} returns this
 */
proto.witbooking.backoffice.insurance.v1.TypologyPercentage.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.TypologyAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologyAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.witbooking.backoffice.insurance.v1.TypologySection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologyAmount}
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.TypologyAmount;
  return proto.witbooking.backoffice.insurance.v1.TypologyAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologyAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologyAmount}
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.TypologySection;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.TypologySection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.TypologyAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologyAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.TypologySection.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TypologySection sections = 1;
 * @return {!Array<!proto.witbooking.backoffice.insurance.v1.TypologySection>}
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.insurance.v1.TypologySection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.insurance.v1.TypologySection, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.insurance.v1.TypologySection>} value
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologyAmount} returns this
*/
proto.witbooking.backoffice.insurance.v1.TypologyAmount.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologySection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection}
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.insurance.v1.TypologySection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologyAmount} returns this
 */
proto.witbooking.backoffice.insurance.v1.TypologyAmount.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.TypologySection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologySection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.toObject = function(includeInstance, msg) {
  var f, obj = {
    amountFrom: (f = msg.getAmountFrom()) && proto.witbooking.backoffice.insurance.v1.Rate.toObject(includeInstance, f),
    amountTo: (f = msg.getAmountTo()) && proto.witbooking.backoffice.insurance.v1.Rate.toObject(includeInstance, f),
    value: (f = msg.getValue()) && proto.witbooking.backoffice.insurance.v1.Rate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.TypologySection;
  return proto.witbooking.backoffice.insurance.v1.TypologySection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologySection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.Rate;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Rate.deserializeBinaryFromReader);
      msg.setAmountFrom(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.insurance.v1.Rate;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Rate.deserializeBinaryFromReader);
      msg.setAmountTo(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.insurance.v1.Rate;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.Rate.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.TypologySection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.TypologySection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmountFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.Rate.serializeBinaryToWriter
    );
  }
  f = message.getAmountTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.insurance.v1.Rate.serializeBinaryToWriter
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.insurance.v1.Rate.serializeBinaryToWriter
    );
  }
};


/**
 * optional Rate amount_from = 1;
 * @return {?proto.witbooking.backoffice.insurance.v1.Rate}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.getAmountFrom = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Rate} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Rate, 1));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Rate|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection} returns this
*/
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.setAmountFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection} returns this
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.clearAmountFrom = function() {
  return this.setAmountFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.hasAmountFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Rate amount_to = 2;
 * @return {?proto.witbooking.backoffice.insurance.v1.Rate}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.getAmountTo = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Rate} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Rate, 2));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Rate|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection} returns this
*/
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.setAmountTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection} returns this
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.clearAmountTo = function() {
  return this.setAmountTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.hasAmountTo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Rate value = 3;
 * @return {?proto.witbooking.backoffice.insurance.v1.Rate}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.getValue = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.Rate} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.Rate, 3));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.Rate|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection} returns this
*/
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.TypologySection} returns this
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.TypologySection.prototype.hasValue = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.Restrictions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.Restrictions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.toObject = function(includeInstance, msg) {
  var f, obj = {
    minStay: (f = msg.getMinStay()) && proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.toObject(includeInstance, f),
    maxStay: (f = msg.getMaxStay()) && proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.toObject(includeInstance, f),
    minNotice: (f = msg.getMinNotice()) && proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.toObject(includeInstance, f),
    maxNotice: (f = msg.getMaxNotice()) && proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.Restrictions;
  return proto.witbooking.backoffice.insurance.v1.Restrictions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.Restrictions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.RestrictionMinStay;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.deserializeBinaryFromReader);
      msg.setMinStay(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.deserializeBinaryFromReader);
      msg.setMaxStay(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.deserializeBinaryFromReader);
      msg.setMinNotice(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.deserializeBinaryFromReader);
      msg.setMaxNotice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.Restrictions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.Restrictions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinStay();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.serializeBinaryToWriter
    );
  }
  f = message.getMaxStay();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.serializeBinaryToWriter
    );
  }
  f = message.getMinNotice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.serializeBinaryToWriter
    );
  }
  f = message.getMaxNotice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.serializeBinaryToWriter
    );
  }
};


/**
 * optional RestrictionMinStay min_stay = 1;
 * @return {?proto.witbooking.backoffice.insurance.v1.RestrictionMinStay}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.getMinStay = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.RestrictionMinStay} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.RestrictionMinStay, 1));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.RestrictionMinStay|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.setMinStay = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.clearMinStay = function() {
  return this.setMinStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.hasMinStay = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RestrictionMaxStay max_stay = 2;
 * @return {?proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.getMaxStay = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay, 2));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.setMaxStay = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.clearMaxStay = function() {
  return this.setMaxStay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.hasMaxStay = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RestrictionMinNotice min_notice = 3;
 * @return {?proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.getMinNotice = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice, 3));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.setMinNotice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.clearMinNotice = function() {
  return this.setMinNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.hasMinNotice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RestrictionMaxNotice max_notice = 4;
 * @return {?proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.getMaxNotice = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice, 4));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions} returns this
*/
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.setMaxNotice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Restrictions} returns this
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.clearMaxNotice = function() {
  return this.setMaxNotice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Restrictions.prototype.hasMaxNotice = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMinStay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMinStay}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.RestrictionMinStay;
  return proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMinStay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMinStay}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMinStay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMinStay} returns this
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinStay.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay;
  return proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay} returns this
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxStay.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice;
  return proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice} returns this
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMinNotice.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice;
  return proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice} returns this
 */
proto.witbooking.backoffice.insurance.v1.RestrictionMaxNotice.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.insurance.v1.Rate.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.insurance.v1.Rate.RateTypeCase = {
  RATE_TYPE_NOT_SET: 0,
  PERCENTAGE: 1,
  CONSTANT: 2
};

/**
 * @return {proto.witbooking.backoffice.insurance.v1.Rate.RateTypeCase}
 */
proto.witbooking.backoffice.insurance.v1.Rate.prototype.getRateTypeCase = function() {
  return /** @type {proto.witbooking.backoffice.insurance.v1.Rate.RateTypeCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.insurance.v1.Rate.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.Rate.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.Rate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.Rate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Rate.toObject = function(includeInstance, msg) {
  var f, obj = {
    percentage: (f = msg.getPercentage()) && proto.witbooking.backoffice.insurance.v1.RatePercentage.toObject(includeInstance, f),
    constant: (f = msg.getConstant()) && proto.witbooking.backoffice.insurance.v1.RateConstant.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.Rate}
 */
proto.witbooking.backoffice.insurance.v1.Rate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.Rate;
  return proto.witbooking.backoffice.insurance.v1.Rate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.Rate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.Rate}
 */
proto.witbooking.backoffice.insurance.v1.Rate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.insurance.v1.RatePercentage;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.RatePercentage.deserializeBinaryFromReader);
      msg.setPercentage(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.insurance.v1.RateConstant;
      reader.readMessage(value,proto.witbooking.backoffice.insurance.v1.RateConstant.deserializeBinaryFromReader);
      msg.setConstant(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.Rate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.Rate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.Rate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.Rate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPercentage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.insurance.v1.RatePercentage.serializeBinaryToWriter
    );
  }
  f = message.getConstant();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.insurance.v1.RateConstant.serializeBinaryToWriter
    );
  }
};


/**
 * optional RatePercentage percentage = 1;
 * @return {?proto.witbooking.backoffice.insurance.v1.RatePercentage}
 */
proto.witbooking.backoffice.insurance.v1.Rate.prototype.getPercentage = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.RatePercentage} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.RatePercentage, 1));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.RatePercentage|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Rate} returns this
*/
proto.witbooking.backoffice.insurance.v1.Rate.prototype.setPercentage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.insurance.v1.Rate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Rate} returns this
 */
proto.witbooking.backoffice.insurance.v1.Rate.prototype.clearPercentage = function() {
  return this.setPercentage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Rate.prototype.hasPercentage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RateConstant constant = 2;
 * @return {?proto.witbooking.backoffice.insurance.v1.RateConstant}
 */
proto.witbooking.backoffice.insurance.v1.Rate.prototype.getConstant = function() {
  return /** @type{?proto.witbooking.backoffice.insurance.v1.RateConstant} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.insurance.v1.RateConstant, 2));
};


/**
 * @param {?proto.witbooking.backoffice.insurance.v1.RateConstant|undefined} value
 * @return {!proto.witbooking.backoffice.insurance.v1.Rate} returns this
*/
proto.witbooking.backoffice.insurance.v1.Rate.prototype.setConstant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.insurance.v1.Rate.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.insurance.v1.Rate} returns this
 */
proto.witbooking.backoffice.insurance.v1.Rate.prototype.clearConstant = function() {
  return this.setConstant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.insurance.v1.Rate.prototype.hasConstant = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.RatePercentage.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.RatePercentage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.RatePercentage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RatePercentage.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.RatePercentage}
 */
proto.witbooking.backoffice.insurance.v1.RatePercentage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.RatePercentage;
  return proto.witbooking.backoffice.insurance.v1.RatePercentage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.RatePercentage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.RatePercentage}
 */
proto.witbooking.backoffice.insurance.v1.RatePercentage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.RatePercentage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.RatePercentage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.RatePercentage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RatePercentage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.insurance.v1.RatePercentage.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.insurance.v1.RatePercentage} returns this
 */
proto.witbooking.backoffice.insurance.v1.RatePercentage.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.RateConstant.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.RateConstant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.RateConstant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RateConstant.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.RateConstant}
 */
proto.witbooking.backoffice.insurance.v1.RateConstant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.RateConstant;
  return proto.witbooking.backoffice.insurance.v1.RateConstant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.RateConstant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.RateConstant}
 */
proto.witbooking.backoffice.insurance.v1.RateConstant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.RateConstant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.RateConstant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.RateConstant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.RateConstant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.witbooking.backoffice.insurance.v1.RateConstant.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.insurance.v1.RateConstant} returns this
 */
proto.witbooking.backoffice.insurance.v1.RateConstant.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation}
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.insurance.v1.InsuranceTaxation;
  return proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation}
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation} returns this
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.insurance.v1.InsuranceTaxation} returns this
 */
proto.witbooking.backoffice.insurance.v1.InsuranceTaxation.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.insurance.v1.InsuranceCalculationBase = {
  ACCOMMODATION_AND_EXTRAS: 0,
  ACCOMMODATION_ONLY: 1
};

goog.object.extend(exports, proto.witbooking.backoffice.insurance.v1);
